export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const REGISTER_START = 'REGISTER_START'
export const LOGOUT = 'USER_LOGOUT'
export const UPDATE_CARD = 'UPDATE_CARD'
export const CHANGE_BACKMODE = 'CHANGE_BACKMODE'